<template>
  <!-- Table Container Card -->
  <b-card>

    <validation-observer ref="accountStatementRules">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="match-height">
          <!-- Account Number -->
          <b-col md="3">
            <InputField
              id="account-number"
              v-model="accountStatementFormData.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter Account Number')"
              type="text"
              :error-name="$t('Account Number')"
              rules="required"
              for="account-number"
              :readonly="isReadonly"
            />
          </b-col>
          <!-- Account Number -->

          <!-- Start Date-->
          <b-col md="3">
            <DatePickerField
              id="start-date"
              v-model="accountStatementFormData.financialDateFrom"
              rules="required"
              :min-date="new Date()"
              :label="$t('Start Date')"
              :error-name="$t('Start Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
            />
          </b-col>
          <!--  Start Date -->

          <!-- End Date-->
          <b-col md="3">
            <DatePickerField
              id="end-date"
              v-model="accountStatementFormData.financialDateTo"
              rules="required"
              :min-date="new Date()"
              :label="$t('End Date')"
              :error-name="$t('End Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
            />
          </b-col>
          <!--  End Date -->
          <b-col
            md="3"
            class="mt-2"
          >
            <Button
              :label="$t('Generate')"
              :loading="isLoading"
              :disabled="isDisabled"
              variant="primary"
              size="md"
              @click="handleSubmit"
            />
          </b-col>
          <!-- Export Options -->
          <b-col
            md="9"
          >
            <h5 class="section-label mb-0">
              {{ $t('Choose Export Option') }}
            </h5>
            <b-form-radio-group
              v-model="exportOption"
              :options="translatedExportTypeOptions"
              class="demo-inline-spacing"
              name="radios-inline"
              stacked
              value-field="value"
              text-field="text"
            />
          </b-col>
          <!-- Export Options -->
        </b-row>
      </b-form>
    </validation-observer>

    <div
      id="account-statement-printer"
    >
      <p id="prints">
        <b-card
          no-body
          class="overflow-hidden"
        >
          <div class="container">
            <div class="column-4">
              <img
                :src="userDetails.institutionLogoURL ? userDetails.institutionLogoURL : reportInfo.orgLogo"
              >
              <p
                v-if="corporateDetails"
                style="font-size: 14px;"
                class="mt-1"
              >
                {{ corporateDetails.registeredAddress }}
              </p>
              <p
                style="font-family: Century Gothic, sans-serif; font-size: 18px; font-weight: 600;"
                class="mt-3"
              >
                {{ reportData.accountName }}
              </p>
              <p style="font-size: 14px; ">
                {{ reportData.address }}
              </p>
            </div>
            <div class="column-8">
              <table
                align="right"
              >
                <tbody>
                  <tr>
                    <td
                      colspan="2"
                      rowspan="7"
                    />
                    <td>
                      <p style="font-size: 16px; font-weight: 600; font-family: Century Gothic, sans-serif;">
                        {{ $t('Statement of Account') }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p style="font-size: 14px; margin-top: -10px;">
                        {{ $t('Period:') }}
                      </p>
                    </td>
                    <td>
                      <p style="margin-top: -10px;">
                        {{ accountStatementFormData.financialDateFrom }} - {{ accountStatementFormData.financialDateTo }}
                      </p></td>
                  </tr>
                  <tr>
                    <td><p style="font-family: Century Gothic, sans-serif; font-size: 14px; font-weight: 600;">
                      {{ $t('Account Summary') }}
                    </p></td>
                  </tr>
                  <tr>
                    <td>
                      <p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                        {{ $t('Account Number:') }}
                      </p></td>
                    <td><p style="font-family: Century Gothic, sans-serif; font-size: 14px; font-weight: 600;">
                      {{ reportData.accountNumber }}
                    </p></td>
                  </tr>
                  <tr>
                    <td><p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                      {{ $t('Product Name:') }}
                    </p></td>
                    <td><p style="font-family: Century Gothic, sans-serif; font-size: 14px; font-weight: 600;">
                      {{ reportData.product }}
                    </p></td>
                  </tr>
                  <tr>
                    <td><p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                      {{ $t('Opening Balance:') }}
                    </p></td>
                    <td><p style="font-family: Century Gothic, sans-serif; font-size: 14px; font-weight: 600;">
                      NGN{{ toFormatAmount(reportData.openingBalance) }}
                    </p></td>
                  </tr>
                  <tr>
                    <td><p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                      {{ $t('Closing Balance:') }}
                    </p></td>
                    <td><p style="font-family: Century Gothic, sans-serif; font-size: 14px; font-weight: 600;">
                      NGN{{ toFormatAmount(reportData.closingBalance) }}
                    </p></td>
                  </tr>

                  <tr>
                    <td>
                      <p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                        {{ $t('Total Credit:') }}&nbsp;&nbsp;&nbsp;&nbsp;
                      </p>
                    </td>
                    <td>
                      <p style="font-family: Century Gothic, sans-serif; font-size: 16px; font-weight: 600;">
                        NGN{{ toFormatAmount(reportData.totalCredit) }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </p>
                    </td>
                    <td>
                      <p style="font-size: 14px; color: #aaa; margin-top: -10px;">
                        {{ $t('Total Debit:') }}
                      </p>
                    </td>
                    <td>
                      <p style="font-family: Century Gothic, sans-serif; font-size: 16px; font-weight: 600;">
                        NGN{{ toFormatAmount(reportData.totalDebit) }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:none;">
                      <br>
                    </td>
                    <td style="border:none;">
                      <br>
                    </td>
                    <td style="border:none;">
                      <br>
                    </td>
                    <td style="border:none;">
                      <br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card>

        <b-table
          ref="accountStatmentTableRef"
          :items="reportData.data"
          :busy="isBusy"
          responsive
          :fields="translatedTableHeaders"
          primary-key="id"
          show-empty
          :empty-text="$t('No records available')"
          class="position-relative table table-bordered"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner
                class="align-middle"
                variant="primary"
              />
            </div>
          </template>
          <template #cell(SN)="data">
            {{ getOverallIndex(data.index) }}
          </template>
          <template #cell(transactionDate)="data">
            <p class="mb-0">
              {{ formatToDateWithDateTime(data.value ) }}
            </p>
          </template>
          <template #cell(debit)="data">
            <p
              class="mb-0"
              style="text-align: right;"
            >
              {{ data.value === 0 ? '' : toFormatAmount(data.value ) }}
            </p>
          </template>
          <template #cell(credit)="data">
            <p
              class="mb-0"
              style="text-align: right;"
            >
              {{ data.value === 0 ? '' : toFormatAmount(data.value ) }}
            </p>
          </template>
          <template #cell(balance)="data">
            <p
              class="mb-0"
              style="text-align: right;"
            >
              {{ toFormatAmount(data.value ) }}
            </p>
          </template>
        </b-table>
      </p>
    </div>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BTable, BSpinner, BRow, BForm, BCol, BFormRadioGroup,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import * as FileSaver from 'file-saver'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toYearWithDate, toDateWithDateTime } from '@/helpers/formatDate'
import { toFormatAmount } from '@/helpers/formatAmount'
import InputField from '../../../forms/InputField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'
import { reportDataDetail } from '../../../../helpers/data'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BRow,
    BCol,
    BForm,
    Button,
    InputField,
    DatePickerField,
    BFormRadioGroup,
    ValidationObserver,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: false,
      required,
      toFormatAmount,
      isLoading: false,
      isDisabled: false,
      showSpinner: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'transactionDate', label: 'Transaction Date' },
        { key: 'financialDate', label: 'Value Date' },
        { key: 'postingReferenceNumber', label: 'Transaction Ref' },
        { key: 'debit', label: 'Debit' },
        { key: 'credit', label: 'Credit' },
        { key: 'narration', label: 'Transaction Details' },
        { key: 'balance', label: 'Balance' },
      ],
      reportData: [],
      accountStatementFormData: {
        accountNumber: '',
        financialDateFrom: '',
        financialDateTo: '',
      },
      exportOption: 'Pdf',
      reportInfo: reportDataDetail,
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        maxDate: 'today',
        defaultDate: '',
        ariaDateFormat: 'd/m/Y',
      },
      exportTypeOptions: [
        { text: 'PDF', value: 'Pdf' },
        { text: 'EXCEL', value: 'Excel' },
        { text: 'PRINT', value: 'Print' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
      corporateDetails: 'operations/getCorporateDetails',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedExportTypeOptions() {
      return this.exportTypeOptions.map(header => ({ ...header, text: header.text ? this.$t(header.text) : header.value }))
    },
  },
  methods: {
    ...mapActions({
      getCustomerAccountStatement: 'reports/getCustomerAccountStatement',
      downloadCustomerAccountStatementReport: 'reports/downloadCustomerAccountStatementReport',
    }),

    handleSubmit() {
      this.$refs.accountStatementRules.validate().then(async success => {
        if (success) {
          this.checkDownloadType()
        }
      })
    },
    checkDownloadType() {
      if (this.exportOption === 'Excel') {
        this.excelExport()
      } else if (this.exportOption === 'Pdf') {
        this.pdfExport()
      } else {
        this.fetchDataForPrinter()
      }
    },
    async fetchDataForPrinter() {
      try {
        this.showSpinner = true
        const response = await this.getCustomerAccountStatement({
          ...this.accountStatementFormData,
          financialDateFrom: toYearWithDate(this.accountStatementFormData.financialDateFrom),
          financialDateTo: toYearWithDate(this.accountStatementFormData.financialDateTo),
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.reportData = data

          // Delay window.print() for 2 sec until data fetched
          setTimeout(() => {
            window.print()
          }, 200)
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },
    async excelExport() {
      try {
        this.showSpinner = true
        this.isBusy = true
        const response = await this.downloadCustomerAccountStatementReport({
          ...this.accountStatementFormData,
          financialDateFrom: toYearWithDate(this.accountStatementFormData.financialDateFrom),
          financialDateTo: toYearWithDate(this.accountStatementFormData.financialDateTo),
          fileExportFormat: 0,
        })
        if (response.status === 200) {
          const fileName = this.$t('Statement of Account')
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
          FileSaver.saveAs(blob, `${fileName}.xlsx`)
          this.alertSuccess({ text: this.$t('Your request to download Statement of Account was successful') })
        }
      } catch (error) {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text()
          const parsed = JSON.parse(text)
          error.response.data = parsed
        }
        this.handleError(error)
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
    async pdfExport() {
      try {
        this.showSpinner = true
        this.isBusy = true
        const response = await this.downloadCustomerAccountStatementReport({
          ...this.accountStatementFormData,
          financialDateFrom: toYearWithDate(this.accountStatementFormData.financialDateFrom),
          financialDateTo: toYearWithDate(this.accountStatementFormData.financialDateTo),
          fileExportFormat: 2,
        })
        if (response.status === 200) {
          const fileName = this.$t('Statement of Account')
          const blob = new Blob([response.data], { type: 'application/pdf' })
          FileSaver.saveAs(blob, `${fileName}.pdf`)
          this.alertSuccess({ text: this.$t('Your request to download Statement of Account was successful') })
        }
      } catch (error) {
        // Parse blob error response before handling
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text()
          const parsed = JSON.parse(text)
          error.response.data = parsed
        }
        this.handleError(error)
      } finally {
        this.showSpinner = false
        this.isBusy = false
      }
    },
    formatToDateWithDateTime: toDateWithDateTime,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
      @media screen {
  #prints {
    display: none;
   }
}

@media print {
   html, body {
     height: 99%;
     page-break-after: avoid !important;
     page-break-before: avoid !important;
     visibility:hidden;
  }
  #account-statement-printer, #account-statement-printer * {
    visibility: visible; border: none;
  }
  #prints, #prints * {
    visibility:visible;
  }
  #prints {
    position:absolute;
    left:0;
    top:0;
    right: 0;
  }
  img {
  max-width: 50%;
  height: auto;
}
}
.container {
      display: flex;
    }
    .column-4 {
      flex: 0 0 33.33%; /* 4 out of 12 columns */
    }
    .column-8 {
      flex: 0 0 66.67%; /* 8 out of 12 columns */
    }
</style>
